import {
  CreateWebPushFormValues,
  DeleteWebPushFormValues,
  TestWebPushFormValues,
} from 'modules/webPush/types';
import { get, post, postForm } from 'services/api';

export const GET_WEB_PUSH_URL = '/integrations/webPush.json';
export const CREATE_WEB_PUSH_URL = '/integrations/createWebPushIntegration';
export const UPDATE_WEB_PUSH_URL = '/integrations/updateWebPushIntegration';
export const DELETE_WEB_PUSH_URL = '/integrations/deleteWebPushIntegration';
export const SEND_WEB_PUSH_URL = '/integrations/sendWebPushNotification';

/**
 * Fetch the web push data
 */
export const getWebPush = () => get(GET_WEB_PUSH_URL);

/**
 * Create web push integration
 */
export const createWebPush = ({
  authType,
  platform,
  fcmSenderId,
  ...rest
}: CreateWebPushFormValues) => {
  const data: { name: string; value: string }[] = [
    { name: 'authType', value: authType },
    { name: 'platform', value: platform },
    ...('fcmJson' in rest ? [{ name: 'fcmJson', value: rest.fcmJson }] : []),
    /**
     * @note These next two fields start uppercase because the create endpoint expects them uppercase,
     * but the fetch endpoint returns them lowercase and the delete/test endpoints expect them lowercase.
     * Hence, the `WebPushIntegration` type has them set to lowercase while we capitalize them just for creation.
     */
    ...('fcmServerKey' in rest ? [{ name: 'FCMServerKey', value: rest.fcmServerKey }] : []),
    { name: 'FCMSenderId', value: fcmSenderId },
  ];

  const formData = new FormData();
  data.forEach(({ name, value }) => formData.append(name, value));
  return postForm(CREATE_WEB_PUSH_URL, formData);
};

/**
 * Delete web push integration
 */
export const deleteWebPush = (params: DeleteWebPushFormValues) => post(DELETE_WEB_PUSH_URL, params);

/**
 * Send web push notification
 */
export const sendWebPush = (params: TestWebPushFormValues) => post(SEND_WEB_PUSH_URL, params);
